import { get, post } from './reuuest'

// export const GetNews = (params) => get('/admin/pub/article/list-'+params.pageSize+'-'+params.currentPage+'.json')
export const GetNews = (params) => get('/admin/pub/article/list?pageSize='+params.pageSize+'&pageNum='+params.pageNum)



// WEBPACK FOOTER //
// ./src/utils/api.js